<div class="container-fuid bg-white default-boxrounded">
    <div class="row">
        <div class="col-auto">
            <h3 class="title" translate="{{personToEdit ? 'Button.EditPerson' : 'Button.AddNewPerson'}}"></h3>
        </div>
    </div>

    <ng-template #rt let-r="result">
        {{r.firstname}} {{r.prefix}} {{r.lastname}}<br />
        <div class="mt-1 information lh-sm">
            {{r.email}}<br />
            {{r.mobile}}
        </div>
    </ng-template>

    <div class="pt-1 pe-4 pb-4 ps-4">
        <form class="row needs-validation has-validation" [formGroup]="form">
            <div class="mb-3 col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
                <label for="firstname" class="form-label" translate="Request.Person.Firstname"></label>
                <input type="text" id="firstname" class="form-control" formControlName="firstname"
                    [value]="person.firstname" placeholder="{{ 'Request.Person.Firstname' | translate }}"
                    (selectItem)="prefillCustomer($event)" [ngbTypeahead]="searchFirstname"
                    popupClass="dropdown-menu-person-dialog" [resultTemplate]="rt" autocomplete="off">
                <app-formcontrol-error-messages [forControl]="firstNameControl"></app-formcontrol-error-messages>
            </div>
            <div class="mb-3 col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
                <label for="prefix" class="form-label" translate="Request.Person.Prefix"></label>
                <input type="text" id="prefix" class="form-control" [value]="person.prefix" formControlName="prefix"
                    placeholder="{{ 'Request.Person.Prefix' | translate }}" autocomplete="off">
                <app-formcontrol-error-messages [forControl]="prefixControl"></app-formcontrol-error-messages>
            </div>

            <div class="mb-3 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                <label for="lastname" class="form-label" translate="Request.Person.LastName"></label>
                <input type="text" id="lastname" class="form-control" [value]="person.lastname"
                    formControlName="lastname" placeholder="{{ 'Request.Person.LastName' | translate }}"
                    (selectItem)="prefillCustomer($event)" [ngbTypeahead]="searchLastname"
                    popupClass="dropdown-menu-person-dialog" [resultTemplate]="rt" autocomplete="off" required>
                <app-formcontrol-error-messages [forControl]="lastNameControl"></app-formcontrol-error-messages>
            </div>

            <div class="mb-3 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                <label for="email" class="form-label" translate>Request.Person.EmailAddress</label>
                <input type="email" id="email" class="form-control" value="{{person.email}}" formControlName="email"
                    placeholder="{{ 'Request.Person.EmailAddress' | translate }}" required email="true"
                    [value]="person.email" (selectItem)="prefillCustomer($event)" [ngbTypeahead]="searchEmail"
                    popupClass="dropdown-menu-person-dialog" [resultTemplate]="rt" autocomplete="off">
                <app-formcontrol-error-messages [forControl]="emailControl"></app-formcontrol-error-messages>
            </div>

            <div class="mb-3 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                <label for="mobile" class="form-label" translate="Request.Person.Mobile"></label>

                <input type="text" id="mobile" class="form-control" value="{{person.mobile}}" formControlName="mobile"
                    placeholder="{{ 'Request.Person.Mobile' | translate }}" required [value]="person.mobile"
                    autocomplete="off">
                <app-formcontrol-error-messages [forControl]="phoneControl"></app-formcontrol-error-messages>

            </div>
            <div class="mb-3 col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
                <label for="personLanguage" class="form-label" translate="Request.Person.Language"><app-info-button
                        labelName="Request.Person.LanguageInfoButton"></app-info-button></label>
                <div ngbDropdown class="dropdown" ngDefaultControl name="personLanguage" id="personLanguage">
                    <button class="btn language dropdown-toggle form-control text-truncate default" type="button"
                        id="dropdownMenu" ngbDropdownToggle>
                        {{ personLanguage | translate }}
                        <em class="bi bi-chevron-down float-end" aria-hidden="true"></em>
                    </button>
                    <div ngbDropdownMenu aria-labelledby="dropdownMenu">
                        <button ngbDropdownItem value="NL" (click)="setPersonLanguage('NL')"
                            translate="Language.Dutch"></button>
                        <button ngbDropdownItem value="EN" (click)="setPersonLanguage('EN')"
                            translate="Language.English"></button>
                    </div>
                </div>
            </div>
            <div class="mb-3 col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
                <label for="identificationMethod" class="form-label"
                    translate="Request.Person.IdentificationMethod"><app-info-button
                        labelName="Request.Person.IdentificationMethodInfoButton"></app-info-button></label>
                <div ngbDropdown class="dropdown" ngDefaultControl name="identificationMethod"
                    id="identificationMethod">
                    <button class="btn language dropdown-toggle form-control text-truncate default" type="button"
                        id="dropdownMenu" [disabled]="cannotChooseIdp()" ngbDropdownToggle>
                        {{ 'ValidationMethod.' + identificationMethod | translate }}
                        <em class="bi bi-chevron-down float-end" aria-hidden="true"></em>
                    </button>
                    <div ngbDropdownMenu aria-labelledby="dropdownMenu">
                        <!-- allowedIdentityProviders, specified in workflow config -->
                        <ng-container *ngFor="let provider of allowedIdentityProviders; let i = index">
                            <button ngbDropdownItem value="{{provider}}" (click)="setIdentityProvider(provider, false)"
                                translate="ValidationMethod.{{provider}}"></button>
                        </ng-container>
                    </div>
                </div>
            </div>

            <div *ngIf="showMessage" class="mb-3 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                <label for="message" class="form-label w-100" translate="Request.Person.PersonalNote">
                    
                    <div class="float-none form-check form-switch">
                        <input formControlName="showPersonalNote"
                            class="switch-form-default float-none form-check-input items" type="checkbox" role="switch"
                            (change)="toggleShowPersonalNote($event)">
                        <label class="form-check-label d-none"></label>
                    </div> <i class="bi bi-question-circle" placement="bottom"
                        ngbTooltip="{{'Request.Person.PersonalNoteInfoButton' | translate}}"></i>
                    <span class="float-end">{{form.controls['message'].value?.length}}/500</span>
                </label>
                <textarea rows="4" id="message" class="form-control" value="{{person.message}}"
                    formControlName="message">
                </textarea>
                <app-formcontrol-error-messages [forControl]="personalNoteControl"></app-formcontrol-error-messages>
            </div>

            <div class="mb-3 w-100">
                <button type="button" class="btn btn-sm btn-outline-primary me-1 float-start" (click)="close()"
                    translate>Button.Close</button>
                <button type="submit" class="btn btn-sm btn-primary ms-1 order-2 float-end" (click)="save()"
                    [disabled]="!form.valid"
                    translate="{{personToEdit ? 'Button.SaveChanges' : 'Button.Add'}}"></button>
                <button type="button" class="btn btn-sm btn-primary ms-1 order-1 float-end" (click)="save(true)"
                    [disabled]="!form.valid" *ngIf="!personToEdit && allowAddAnother"
                    translate="Button.AddAnother"></button>
            </div>
        </form>
    </div>
</div>